"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Util = void 0;
const Config_1 = require("../Config");
const Error_1 = require("./Error");
const buffer_1 = require("buffer");
class Util {
    static promiseWithTimeout(promise, timeoutPeriod) {
        const timeoutArg = process.env.timeoutInMilliseconds ? parseInt(process.env.timeoutInMilliseconds) : undefined;
        const timeout = Util.timeoutAsPromise(timeoutArg || timeoutPeriod || Config_1.config.timeoutInMilliseconds);
        return Promise.race([promise, timeout]);
    }
    static toBase64Url(notBase64Url) {
        let temp = notBase64Url;
        if (Array.isArray(notBase64Url)) {
            temp = Uint8Array.from(temp);
        }
        if (temp instanceof Uint8Array) {
            temp = temp.buffer;
        }
        if (temp instanceof ArrayBuffer && !(temp instanceof buffer_1.Buffer)) {
            temp = buffer_1.Buffer.from(temp);
        }
        const base64 = temp instanceof buffer_1.Buffer ? temp.toString("base64") : temp;
        return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=*$/g, "");
    }
    static toArrayBuffer(notArrayBuffer) {
        let temp = notArrayBuffer;
        if (typeof temp === "string") {
            temp = buffer_1.Buffer.from(temp.replace(/-/g, "+").replace(/_/g, "/"), "base64");
        }
        if (temp instanceof buffer_1.Buffer || Array.isArray(temp)) {
            temp = new Uint8Array(temp);
        }
        return temp.buffer;
    }
    static timeoutAsPromise(timeout) {
        return new Promise((_, reject) => {
            setTimeout(() => {
                reject(Error_1.CustomerAuthnError.TIMEOUT);
            }, timeout);
        });
    }
}
exports.Util = Util;
//# sourceMappingURL=Util.js.map